var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 14.2302V8.98022C8.5 8.56601 8.16421 8.23022 7.75 8.23022H6.25C5.83579 8.23022 5.5 8.56601 5.5 8.98022V14.2282L0.608533 14.2284C0.306441 14.2274 0.056033 14.0072 0.0082252 13.7185L0 13.6199V5.82948C0.0105124 5.63939 0.0946508 5.46087 0.234578 5.33177L7.00311 0.230225L13.7654 5.33177C13.9051 5.46103 13.9892 5.63946 14 5.82948V13.6218C13.9986 13.9575 13.7266 14.2292 13.3908 14.2302H8.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFull);
export default __webpack_public_path__ + "static/media/home-full.eceb8144.svg";
export { ForwardRef as ReactComponent };